exports.PAYMENT_TYPES = {
  AUTO_DEBIT: 'auto_debit',
  ONE_OFF: 'one_off',
  SAVE_CARD: 'save_card',
};

exports.WEB_SDK_CHANNEL = 'web_sdk';

exports.THREEDS_METHODS = {
  REDIRECT: 'redirect',
  IFRAME: 'iframe',
};
exports.CONFIG_TYPE = {
  APPLE_PAY: 'applePay',
  GOOGLE_PAY: 'googlePay',
  SAMSUNG_PAY: 'samsungPay',
  GENERAL: 'general',
};

exports.CLICK_TO_PAY_PRELOAD_FLOWS = [
  'aba_payway',
  'csuc',
  'doku',
  'geidea',
];

exports.ABA_FORM_CONFIGS = {
  TARGET: 'aba_webservice',
  ID: 'aba_merchant_request',
};

exports.CSUC_CONFIG = {
  CONTAINERS: {
    PAYMENT_LIST: 'csuc-buttonPaymentListContainer',
    EMBEDDED_PAYMENT: 'csuc-embeddedPaymentContainer',
  },
  SELECTORS: {
    PAYMENT_SELECTION: '#csuc-buttonPaymentListContainer',
    PAYMENT_SCREEN: '#csuc-embeddedPaymentContainer',
  },
};

exports.LANGUAGES = {
  EN: 'en',
  AR: 'ar',
};

exports.CURRENCY_CODES = {
  AED: 'AED',
  KWD: 'KWD',
  SAR: 'SAR',
};

exports.CUSTOM_ICON_CURRENCIES = [
  this.CURRENCY_CODES.AED,
  this.CURRENCY_CODES.SAR,
];

exports.WALLET_NAMES = {
  apple_pay: 'Apple Pay',
  google_pay: 'Google Pay',
  stc_pay: 'STCPay',
  urpay: 'URPay',
  samsung_pay: 'Samsung Pay',
  wallet: 'Wallet',
};

// Constants for One Last Check events (dispatched on window as CustomEvent)
exports.ONE_LAST_CHECK_EVENTS = {
  SHOWN: 'ottu:one-last-check:shown',
  CONFIRMED: 'ottu:one-last-check:confirmed',
  EDIT_REQUESTED: 'ottu:one-last-check:edit-requested',
};

// Constants for event types
exports.EVENT_TYPES = {
  CVV_IFRAME_READY: 'cvv-iframe-ready',
  IFRAME_READY: 'iframe-ready',
  VALID_CARD_FIELD: 'validCardField',
  VALID_CVV_FIELD: 'validCvvField',
  HANDLE_PAYMENT_PROCESS: 'handlePaymentProcess',
  CHANGE_HEIGHT: 'changeHeight',
  CARD_ENCRYPTION_STARTED: 'cardEncryptionStarted',
  ENCRYPTION_FAILURE: 'encryptionFailure',
};

// Constants for CSS classes
exports.CSS_CLASSES = {
  CVV_STYLES: 'cvv-styles',
  IFRAME_FADE: 'iframe-fade',
  IFRAME_VISIBLE: 'iframe-visible',
  DISPLAY_NONE: 'd-none',
  DISABLED_PAY_BUTTON: 'ottu__sdk-disabled-pay-button',
  IFRAME_TRANSITION_CONTAINER: 'iframe-transition-container',
  IFRAME_TRANSITION_ABSOLUTE: 'iframe-transition-absolute',
  LOADER_FADE_OUT: 'loader-fade-out',
  SAVED_CARD_LOADER_FADE_OUT: 'fade-out',
  SAVED_CARD_LOADER_LOADED: 'loaded',
};

// Constants for status values
exports.STATUS = {
  ERROR: 'error',
  CANCELED: 'canceled',
  FAILED: 'failed',
};

// Constants for HTTP status codes
exports.HTTP_STATUS = {
  BAD_REQUEST: 400,
  INTERNAL_SERVER_ERROR: 500,
};

// Constants for iframe types
exports.IFRAME_TYPES = {
  CARD: 'card',
  CVV: 'cvv',
};

// Constants for script properties
exports.SCRIPT_PROPS = {
  TYPE_JAVASCRIPT: 'text/javascript',
};

// Constants for height adjustments
exports.HEIGHT_ADJUSTMENTS = {
  ONSITE_FORM_PADDING: 59,
};

// Constants for Samsung Pay
exports.SAMSUNG_PAY_CONFIG = {
  VERSION: '2',
  PROTOCOL: 'PROTOCOL_3DS',
  AMOUNT_OPTION: 'FORMAT_TOTAL_PRICE_ONLY',
  ALLOWED_BRANDS: ['visa', 'mastercard'],
  DEFAULT_ENVIRONMENT: 'STAGE',
};

// Constants for Apple Pay networks and their minimum required versions
exports.APPLE_PAY_NETWORK_VERSIONS = {
  amex: 1,
  bancomat: 14,
  bancontact: 14,
  bankAxept: 15,
  cartesBancaires: 4,
  chinaUnionPay: 1,
  dankort: 13,
  discover: 1,
  eftpos: 4,
  electron: 4,
  elo: 5,
  girocard: 11,
  himyan: 15,
  interac: 1,
  jaywan: 15,
  jcb: 2,
  mada: 5,
  maestro: 4,
  masterCard: 1,
  meeza: 15,
  mir: 11,
  myDebit: 15,
  NAPAS: 15,
  postFinanceAG: 15,
  privateLabel: 1,
  quicPay: 3,
  visa: 1,
  vPay: 4
}

exports.CARDS_SVG = {
  VISA: process.env.SERVER_URL + '/v3/img/VISA.svg',
  MASTERCARD: process.env.SERVER_URL + '/v3/img/MASTERCARD.svg',
  AMEX: process.env.SERVER_URL + '/v3/img/AMEX.svg',
  DISCOVER: process.env.SERVER_URL + '/v3/img/DISCOVER.svg',
  JCB: process.env.SERVER_URL + '/v3/img/JCB.svg',
  DINERS: process.env.SERVER_URL + '/v3/img/DINERS.svg',
  CUP: process.env.SERVER_URL + '/v3/img/CUP.svg',
  MAESTRO: process.env.SERVER_URL + '/v3/img/MAESTRO.svg',
  STC_PAY: process.env.SERVER_URL + '/v3/img/STCPAY.svg',
  URPAY: process.env.SERVER_URL + '/v3/img/URPAY.svg',
  CHECKOUTCOM: process.env.SERVER_URL + '/v3/img/CHECKOUTCOM.svg',
  RAJHI: process.env.SERVER_URL + '/v3/img/RAJHI.svg',
};

exports.APPLE_PAY_FALLBACKS = {
  BUTTON_COLOR: 'black',
  BUTTON_LOCALE: 'en',
  BUTTON_TYPE: 'plain',
};
